export class TimeoutError extends Error {
  constructor(label: string) {
    super(`${label} timed out`);
    this.name = 'TimeoutError';
  }
}

/**
 * Races a promise against a deadline so the UI can never hang on a Firebase
 * call. The underlying promise keeps running (writes still land when the
 * connection returns) — we simply stop blocking on it.
 */
export function withTimeout<T>(promise: Promise<T>, ms: number, label = 'Request'): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const timer = setTimeout(() => reject(new TimeoutError(label)), ms);
    promise.then(
      (value) => {
        clearTimeout(timer);
        resolve(value);
      },
      (error) => {
        clearTimeout(timer);
        reject(error);
      }
    );
  });
}

export function isTimeout(error: unknown): boolean {
  return error instanceof TimeoutError;
}
